import { Component, OnInit, Input, Inject, DOCUMENT, ChangeDetectorRef } from '@angular/core';
import { ErrCrrUtility, inputTypeConfig } from '../../err-crr-utility';
import { ErrorCorrectionService } from 'src/app/services/errorCorrectionClm.service';
import { DatePipe } from '@angular/common';
import { SESSION_STORAGE, WebStorageService } from 'ngx-webstorage-service';
import { forkJoin } from 'rxjs';
import { Constants } from 'src/app/data-models/constants.enum';
import { MdeService } from 'src/app/services/tabs/mde.service';
import { DomSanitizer } from '@angular/platform-browser';
import { Params } from '@angular/router';
import { SessionStorageUtility } from 'src/app/reports/utility/sessionstorage.utility';

@Component({
    selector: 'app-err-crr-member-catg',
    templateUrl: './err-crr-member-catg.component.html',
    styleUrls: ['./err-crr-member-catg.component.css'],
    standalone: false
})
export class ErrCrrMemberCatgComponent extends ErrCrrUtility implements OnInit {
  private static readonly CONTRACT_HIGHLIGHT_ERROR_CODES: string[] = ['02240', '02256', 'PYRTYPCD01', 'PYRTYPCD02', 'CNTRT01'];
  private static readonly CMS_MBI_HIGHLIGHT_ERROR_CODES: string[] = ['EXTID01'];
  @Input() selectedRow: any;
  @Input() routeParam: Params;
  public clmDta;
  public correctionTarget: any = null;
  private mbiTarget: any = null;
  private contractTarget: any = null;
  public open: boolean = true;
  changeBtnCls: string;
  memberClmInfoObj: any = {};
  public cmsContrctNoDtls: any = {};
  memberInfoFieldMapperObj= {};
  public showHideConfig = {};
  public invalidFieldStatus = {};
  inputTypeConfig = inputTypeConfig;
  public addressKeyMapping = {
    addinfo1:'loop2010BAddress.addressInformation1',
    addinfo2:'loop2010BAddress.addressInformation2',
    city:'loop2010BCityStateZipCode.cityName',
    postalCode:'loop2010BCityStateZipCode.postalCode',
    countryCode:'loop2010BCityStateZipCode.countryCode',
    stateorProvCode:'loop2010BCityStateZipCode.stateorProvCode'
};
private readonly section = 'Member Information';
private readonly memberInfoMapping = {
  memberName : 'Member Name',
  dob:'Date of Birth',
  gender:'Gender',
  memberCMSMbi: 'Member CMS/MBI',
  memberAddress: 'Member Address',
  CMSContractNo: 'CMS Contract Number',
  
}
  public cancelParamObj = {};
  public saveParamObj = {};

  get mbiClmInfoObj(): any {
    return this.mbiTarget?.obj || this.memberClmInfoObj;
  }

  get mbiJsonKey(): string {
    return `${this.mbiTarget?.nm1Key || 'loop2010BNM1'}.memberCMS_MBI`;
  }

  get cmsContrctRefKey(): string {
    return this.contractTarget?.refKey || 'loop2010BReference';
  }

  collapsiblePanel1: boolean = true;
  constructor(private errorCorrectionService: ErrorCorrectionService,
    sanitized: DomSanitizer,
    @Inject(DOCUMENT) private readonly document: Document,@Inject(SESSION_STORAGE)public sessionStorage:WebStorageService,public datePipe: DatePipe,  private readonly mdeService:MdeService, private readonly cdr: ChangeDetectorRef) { 
      super(sanitized);
    }

  ngOnInit() {
    this.fetchErrCrrData();
    this.changeBtnCls = "changeBtn-" + this.getUuid();
  }

  getUuid() {
    return (this.selectedRow.medClmSk ? this.selectedRow.medClmSk : `${this.selectedRow.fileKey}_${this.selectedRow.clmId}`) + "" + this.selectedRow.rowIndex;  }

  toggleOpen() {
    this.open = !this.open;
  }

  fetchErrCrrData() {
    const viewingBy =SessionStorageUtility.getSessionStorageData(this.sessionStorage,Constants.viewingBy);
    forkJoin(
      {
        clmData: this.errorCorrectionService.getErrorCorrectionDetails(this.selectedRow.clmType, this.selectedRow.medClmSk, this.selectedRow.partySk),
        state: this.errorCorrectionService.getState(),
        gender : this.errorCorrectionService.getQualifierdropdown(Constants.member,this.selectedRow.clmType,Constants.memberUISec,Constants.memberRefCol,true),
        errorHighLight: this.errorCorrectionService.errorFieldHighlight(this.selectedRow,viewingBy.id)
      }
    ).subscribe(data => {
      // Defer to a fresh macrotask so binding changes never land inside an
      // in-progress change-detection cycle (forkJoin can emit synchronously).
      setTimeout(() => {
        this.clmDta = data.clmData;
        this.listConfig['state'] = data.state;
        this.listConfig['gender'] = data.gender;
        this.errorHighlight = data.errorHighLight;
        this.extractMemberClmInfo();
        this.mapErrorHighlightData();
        this.dataLoading = false;
        this.cdr.detectChanges();
      });
    }, error => {
      this.dataLoading = false;
    });
  }
  mapErrorHighlightData() {
    for(const key in this.memberInfoMapping){
      this.updateMatchErrorHightlightObj(this.section,this.memberInfoMapping[key]);
    }
    this.updateCmsMbiErrorCodeHighlight();
    this.updateContractErrorCodeHighlight();
    this.updateUnmatchErrorHighlightObj(this.section);
  }

  private updateCmsMbiErrorCodeHighlight() {
    const sectionErrors = this.getErrorHighlightSection(this.section, '-1');
    const cmsMbiFieldKey = ['-1', this.section, this.memberInfoMapping.memberCMSMbi].join('.');
    const currentMatches = this.getFieldValue(this.errorHighlightMatch, cmsMbiFieldKey) || [];
    const extIdErrorTexts = [];

    for (const item of sectionErrors) {
      if (ErrCrrMemberCatgComponent.CMS_MBI_HIGHLIGHT_ERROR_CODES.indexOf(this.getErrorCode(item)) === -1) {
        continue;
      }

      item.match = true;
      const errorText = `${item.errorCode}-${item.errorDescription}`;
      extIdErrorTexts.push(errorText);
      if (currentMatches.indexOf(errorText) === -1) {
        currentMatches.push(errorText);
      }
    }

    if (currentMatches.length > 0) {
      this.updateClmAttribute(this.errorHighlightMatch, cmsMbiFieldKey, currentMatches, true);
    }

    const memberAddressKey = ['-1', this.section, this.memberInfoMapping.memberAddress].join('.');
    const memberAddressMatches = this.getFieldValue(this.errorHighlightMatch, memberAddressKey) || [];
    if (memberAddressMatches.length > 0 && extIdErrorTexts.length > 0) {
      const retainedAddressMatches = memberAddressMatches.filter(errorText => extIdErrorTexts.indexOf(errorText) === -1);
      this.updateClmAttribute(
        this.errorHighlightMatch,
        memberAddressKey,
        retainedAddressMatches.length > 0 ? retainedAddressMatches : null,
        true
      );
    }
  }

  private updateContractErrorCodeHighlight() {
    const sectionErrors = this.getErrorHighlightSection(this.section, '-1');
    const contractFieldKey = ['-1', this.section, this.memberInfoMapping.CMSContractNo].join('.');
    const currentMatches = this.getFieldValue(this.errorHighlightMatch, contractFieldKey) || [];

    for (const item of sectionErrors) {
      if (ErrCrrMemberCatgComponent.CONTRACT_HIGHLIGHT_ERROR_CODES.indexOf(this.getErrorCode(item)) === -1) {
        continue;
      }

      item.match = true;
      const errorText = `${item.errorCode}-${item.errorDescription}`;
      if (currentMatches.indexOf(errorText) === -1) {
        currentMatches.push(errorText);
      }
    }

    if (currentMatches.length > 0) {
      this.updateClmAttribute(this.errorHighlightMatch, contractFieldKey, currentMatches, true);
    }
  }

  private getErrorCode(item: any): string {
    return String(item?.errorCode || item?.errCode || item?.code || '').trim().toUpperCase();
  }

  private getErrorDataValue(errorCodes: string[]): string {
    const sectionErrors = this.getErrorHighlightSection(this.section, '-1') || [];
    const errorItem = sectionErrors.find(item =>
      errorCodes.indexOf(this.getErrorCode(item)) !== -1 && item?.dataValInErr
    );
    return String(errorItem?.dataValInErr || '').trim();
  }

  private hasCorrectionError(errorCodes: string[], fieldName?: string): boolean {
    const sectionErrors = this.getErrorHighlightSection(this.section, '-1') || [];
    // show-when-null: also enable when the backend maps the error to this field (claimFiled),
    // so a null-valued contract/MBI field still renders for correction (uncomment to re-enable).
    // const targetField = String(fieldName || '').trim().toLowerCase();
    // return sectionErrors.some(item => errorCodes.indexOf(this.getErrorCode(item)) !== -1
    //   || (!!targetField && String(item?.claimFiled || '').trim().toLowerCase() === targetField));
    return sectionErrors.some(item => errorCodes.indexOf(this.getErrorCode(item)) !== -1);
  }

  private toLoopCandidates(list: any, basePath: string, meta: any): any[] {
    return (Array.isArray(list) ? list : []).map((obj, arrayIndex) =>
      ({ ...meta, obj, arrayIndex, path: `${basePath}[${arrayIndex}]` }));
  }

  // Member CMS/MBI is carried by the subscriber loop (2010B) and by the other subscriber loop (2320).
  private getMbiCandidates(): any[] {
    const subscriber = this.clmDta?.billingProvider?.[0]?.subscriber?.[0] || {};
    return [
      ...this.toLoopCandidates(subscriber.loop2010BName,
        'billingProvider[0].subscriber[0].loop2010BName', { nm1Key: 'loop2010BNM1' }),
      ...this.toLoopCandidates(subscriber.claim?.[0]?.loop2320OtherSubscriber?.loop2320Name,
        'billingProvider[0].subscriber[0].claim[0].loop2320OtherSubscriber.loop2320Name', { nm1Key: 'loop2320NM1' })
    ];
  }

  // CMS contract number (REF*2U) is carried by the 2010B loop and by the other payer loop (2330B).
  private getContractCandidates(): any[] {
    const subscriber = this.clmDta?.billingProvider?.[0]?.subscriber?.[0] || {};
    return [
      ...this.toLoopCandidates(subscriber.loop2010BName,
        'billingProvider[0].subscriber[0].loop2010BName', { refKey: 'loop2010BReference' }),
      ...this.toLoopCandidates(subscriber.claim?.[0]?.loop2330BOtherPayerName?.loop2330BName,
        'billingProvider[0].subscriber[0].claim[0].loop2330BOtherPayerName.loop2330BName', { refKey: 'loop2330Ref' })
    ];
  }

  private getCandidateMbi(candidate: any): string {
    return String(candidate?.obj?.[candidate?.nm1Key]?.memberCMS_MBI || '').trim();
  }

  private findContractRefIndex(candidate: any, contractValue: string): number {
    const references = Array.isArray(candidate?.obj?.[candidate?.refKey]) ? candidate.obj[candidate.refKey] : [];
    return references.findIndex(reference =>
      String(reference?.referenceIdentQual || '').trim().toUpperCase() === '2U'
      && (!contractValue || String(reference?.referenceIdent || '').trim() === contractValue)
    );
  }

  private buildCorrectionTarget(): void {
    const mbiCandidates = this.getMbiCandidates();
    const errorMbi = this.getErrorDataValue(ErrCrrMemberCatgComponent.CMS_MBI_HIGHLIGHT_ERROR_CODES);
    this.mbiTarget = (errorMbi && mbiCandidates.find(candidate => this.getCandidateMbi(candidate) === errorMbi))
      || mbiCandidates.find(candidate => candidate.obj === this.memberClmInfoObj)
      || mbiCandidates[0]
      || null;

    const contractCandidates = this.getContractCandidates();
    const contractValue = this.getErrorDataValue(ErrCrrMemberCatgComponent.CONTRACT_HIGHLIGHT_ERROR_CODES);
    this.contractTarget = (contractValue && contractCandidates.find(candidate => this.findContractRefIndex(candidate, contractValue) >= 0))
      || contractCandidates.find(candidate => this.findContractRefIndex(candidate, '') >= 0)
      || contractCandidates.find(candidate => candidate.obj === this.memberClmInfoObj)
      || contractCandidates[0]
      || null;
    this.cmsContrctNoDtls = this.contractTarget?.obj || this.memberClmInfoObj;

    const matchedRefIndex = this.findContractRefIndex(this.contractTarget, contractValue);
    const contractReferenceIndex = matchedRefIndex >= 0 ? matchedRefIndex : this.findContractRefIndex(this.contractTarget, '');

    this.correctionTarget = {
      member: {
        jsonPath: `${this.mbiTarget?.path}.${this.mbiJsonKey}`,
        arrayIndex: this.mbiTarget?.arrayIndex,
        field: 'memberCMS_MBI',
        enabled: this.hasCorrectionError(ErrCrrMemberCatgComponent.CMS_MBI_HIGHLIGHT_ERROR_CODES, this.memberInfoMapping.memberCMSMbi)
      },
      contract: {
        jsonPath: `${this.contractTarget?.path}.${this.cmsContrctRefKey}[${contractReferenceIndex >= 0 ? contractReferenceIndex : 'new'}].referenceIdent`,
        memberArrayIndex: this.contractTarget?.arrayIndex,
        arrayIndex: contractReferenceIndex,
        field: 'referenceIdent',
        qualifier: '2U',
        enabled: this.hasCorrectionError(ErrCrrMemberCatgComponent.CONTRACT_HIGHLIGHT_ERROR_CODES, this.memberInfoMapping.CMSContractNo)
      }
    };
  }
  
  extractMemberClmInfo(){
    const memberObj = this.clmDta.billingProvider[0].subscriber[0].loop2010BName;
    const selectedRowMbi = String((this.selectedRow && (this.selectedRow.mbi || this.selectedRow.memberMbi || this.selectedRow.memberCMS_MBI)) || '').trim();
    const subscriberMembers = memberObj.filter(memberItem => memberItem && memberItem.loop2010BNM1 && memberItem.loop2010BNM1.entityIdCode === 'IL');

    const selectedMbiMember = selectedRowMbi ?
      subscriberMembers.find(memberItem => String((memberItem && memberItem.loop2010BNM1 && memberItem.loop2010BNM1.memberCMS_MBI) || '').trim() === selectedRowMbi)
      : null;

    this.memberClmInfoObj = selectedMbiMember
      || subscriberMembers.find(memberItem => String((memberItem && memberItem.loop2010BNM1 && memberItem.loop2010BNM1.memberCMS_MBI) || '').trim() !== '')
      || subscriberMembers[0]
      || memberObj[0]
      || {};

     this.buildCorrectionTarget();

  }


  collapseEditor(event) {
    if (event.type === 'change') {
      if (event.isInvalid) {
        this.invalidFieldStatus[event.field] = true;
        return
      }
      this.isDataModified = true;
      this.updateClmData(event);
      if(event.field !== 'CmsContractNumber' && event.inputType !== inputTypeConfig.address && event.inputType !== inputTypeConfig.entityName){
        const isMbiField = event.key === this.mbiJsonKey;
        this.updateClmAttribute(isMbiField ? this.mbiClmInfoObj : this.memberClmInfoObj, event.key, event.value, isMbiField);
      }
      
     }
    if (event.type === 'validation') {
      this.invalidFieldStatus[event.field] = event.isInvalid;
      return
    }
      
      this.invalidFieldStatus[event.field] = false;
      this.showHideConfig[event.field] = false;
  }

  updateClmData(event){
    
    if (event.field === "CmsContractNumber") {
       const refKey = this.cmsContrctRefKey;
       const cmsContrctNoObj = this.cmsContrctNoDtls || this.memberClmInfoObj;
       cmsContrctNoObj[refKey] = Array.isArray(cmsContrctNoObj[refKey]) ? cmsContrctNoObj[refKey] : [];
       let contractReference = cmsContrctNoObj[refKey].find(reference =>
         String(reference?.referenceIdentQual || '').trim().toUpperCase() === '2U'
       );
       if (!contractReference) {
         contractReference = { referenceIdentQual: '2U', referenceIdent: '' };
         cmsContrctNoObj[refKey].push(contractReference);
       }
       contractReference.referenceIdent = event.value;
       const contractReferenceIndex = cmsContrctNoObj[refKey].indexOf(contractReference);
       if (this.correctionTarget?.contract) {
         this.correctionTarget.contract.arrayIndex = contractReferenceIndex;
         this.correctionTarget.contract.jsonPath = `${this.contractTarget?.path}.${refKey}[${contractReferenceIndex}].referenceIdent`;
       }
    }
    else if(event.inputType === inputTypeConfig.date){
      event.value = this.encodeDateFormat(event.value);
    }
  }

  getCmsContrcNo(attrValidation: boolean = false,cmsCntrctObj){
    const references = cmsCntrctObj && Array.isArray(cmsCntrctObj[this.cmsContrctRefKey])
      ? cmsCntrctObj[this.cmsContrctRefKey]
      : [];
    const contractReference = references.find(reference =>
      String(reference?.referenceIdentQual || '').trim().toUpperCase() === '2U'
    ) || references[0];
    
    if(attrValidation){
        return contractReference && contractReference.referenceIdent;
    }else{
      return contractReference ? cmsCntrctObj : null;
    }   
  }

  getGenderCode(){
    const gCode = this.memberClmInfoObj['loop2010BDemographicInformation'].genderCode;
    return gCode ? gCode : " ";
  }

  getDateOfBirth() {
    const  date = this.memberClmInfoObj['loop2010BDemographicInformation'].dateTimePeriod;
    return date ? this.decodeDateFormat(date) : "";
  }

  getMemberAddr() {
    if(this.memberClmInfoObj['loop2010BAddress']){
    const addr1 = this.memberClmInfoObj['loop2010BAddress'].addressInformation1 ? this.memberClmInfoObj['loop2010BAddress'].addressInformation1 + "  " : "";
    const addr2 = this.memberClmInfoObj['loop2010BAddress'].addressInformation2 ? this.memberClmInfoObj['loop2010BAddress'].addressInformation2 + "  " : "";
    const city = this.memberClmInfoObj['loop2010BCityStateZipCode'].cityName ? this.memberClmInfoObj['loop2010BCityStateZipCode'].cityName + ", " : "";
    const postal = this.memberClmInfoObj['loop2010BCityStateZipCode'].postalCode ?  this.memberClmInfoObj['loop2010BCityStateZipCode'].postalCode : "";
    const state = this.getFieldLabel("state", this.memberClmInfoObj['loop2010BCityStateZipCode'].stateorProvCode);
    return  addr1 + addr2 + city + state + " " + postal;
    }
    
  }

  getMemberCmsMbi() {
    return this.getCandidateMbi(this.mbiTarget);
  }

  getMemberName(){
    if( this.memberClmInfoObj){
      const fName = this.memberClmInfoObj['loop2010BNM1'].nameFirst || "";
      const mName = this.memberClmInfoObj['loop2010BNM1'].nameMiddle || "";
      const lName = this.memberClmInfoObj['loop2010BNM1'].nameLastOrgName || "";
      const sName = this.memberClmInfoObj['loop2010BNM1'].nameSuffix || "";
      return fName + " " +mName+ " " + lName + " "+sName;
    }
  }
  cancelMember(){
    const accordionsEditorList = [this.showHideConfig];
    const invalidEntry = this.isEditorOpen(accordionsEditorList);
     this.cancelParamObj =  {
      "invalidEntry" : invalidEntry,
      ...this.getCollapsePanelParam()
    }
    this.cancel(this.cancelParamObj);
  }

  collapseMemberPanel(){
    this.collapsePanel(this.getCollapsePanelParam());
  }

  getCollapsePanelParam(){
    return {uuid:this.getUuid(),docObj:this.document,session:this.sessionStorage,errCrrService:this.errorCorrectionService};
  }
  closeMemberPopUp() {
    this.closePopUp(this.getCollapsePanelParam());
  }

  saveMemberClaim(isResubmitFlow :boolean =false){
    const accordionsEditorList = [this.showHideConfig];
    const {invalidEntry,isSaveEligible} = this.applyEditedChanges(accordionsEditorList,this.document,this.changeBtnCls);
    this.saveParamObj = {
        "isResubmitFlow": isResubmitFlow,
        "invalidEntry":invalidEntry,
        "isSaveEligible":isSaveEligible,
        "allClmData":this.clmDta,
        "correctionTarget": this.correctionTarget,
        "session":this.sessionStorage,
        "errCrrService":this.errorCorrectionService,
        "mdeService":this.mdeService,
        "uuid":this.getUuid(),
        "docObj":this.document
       }
    this.saveClaim(this.saveParamObj);
   
  }

  colpseMemberResubmitPopUp(event){
    this.collapseResubmitPop(event,this.getCollapsePanelParam());
  }


}
